import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { Accordion, AccordionDetails, AccordionSummary } from '@material-ui/core';
import { Circle, DocumentTable } from 'components';
import { Colors, useGlobalStyles, useGlobalText, isAdmin, docTypes } from 'utils';
import { CreateOfficeInputs } from '../createOffice';
import { OfficeManagement } from './core/officeManagement';
import { PayrollSetup } from './core/payrollSetup';
import { officeDockTypes } from './core/constant';
import { Expenses } from './core/expenses';
import { authService } from '../../../store/mc/mc.service';
import { httpRequestsOnLoadActions, httpRequestsOnSuccessActions, mcActions, officeActions } from 'store';
import { DirectoryAccess } from './core';

const ADD_OFFICE_DOCK = 'ADD_OFFICE_DOCK';
const DELETE_OFFICE_DOCK = 'DELETE_OFFICE_DOCK';
const EDIT_OFFICE_DOCK = 'EDIT_OFFICE_DOCK';

export const OfficeInfoTable = ({ handleChangeName }) => {
  const { officeById } = useSelector((state) => ({
      officeById: state.offices.officeById,
    }),
  );
  const globalStyle = useGlobalText();
  const globalInputs = useGlobalStyles();
  const dispatch = useDispatch();
  const info = officeById;


  const handleAddDocument = async (img) => {
    try {
      dispatch(httpRequestsOnSuccessActions.removeSuccess(ADD_OFFICE_DOCK))
      await authService.addOfficeDocument(img, info?.id);
      dispatch(httpRequestsOnSuccessActions.appendSuccess(ADD_OFFICE_DOCK))
      dispatch(httpRequestsOnLoadActions.removeLoading(ADD_OFFICE_DOCK));
      dispatch(officeActions.getOfficeById(info?.id, 'noLoad'));
    } catch (e) {
      dispatch(httpRequestsOnLoadActions.removeLoading(ADD_OFFICE_DOCK));
    }
  };

  const handleSetDocStatus = async (doc, type) => {
    try {
      dispatch(httpRequestsOnLoadActions.appendLoading(EDIT_OFFICE_DOCK));
      const sendInfo = {
        ...doc,
        status: type !== 'edit' ? doc.status === 'ACTIVE' ? 'INACTIVE' : 'ACTIVE' : doc.status,
      };
      await authService.editOfficeDocument(info?.id, doc?.id, sendInfo);
      dispatch(officeActions.getOfficeById(info.id, 'noLoad'));
      dispatch(httpRequestsOnLoadActions.removeLoading(EDIT_OFFICE_DOCK));
      dispatch(httpRequestsOnSuccessActions.appendSuccess(EDIT_OFFICE_DOCK));
    } catch (e) {
      dispatch(httpRequestsOnLoadActions.removeLoading(EDIT_OFFICE_DOCK));
    }
  };

  const handleDeleteFile = async (doc) => {
    try {
      dispatch(httpRequestsOnLoadActions.appendLoading(DELETE_OFFICE_DOCK));
      await authService.deleteOfficeDocument(info.id, doc.id);
      dispatch(httpRequestsOnLoadActions.removeLoading(DELETE_OFFICE_DOCK));
      dispatch(httpRequestsOnSuccessActions.appendSuccess(DELETE_OFFICE_DOCK));
      dispatch(officeActions.getOfficeById(info.id, 'noLoad'));
    } catch (e) {
      dispatch(httpRequestsOnLoadActions.removeLoading(DELETE_OFFICE_DOCK));
    }
  };

  return (
    <div className="accordion-style">
      <Accordion>
        <AccordionSummary
          className={'accordion'}
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <div className={globalInputs.centerItem}>
            {info && <Circle number={1} back={Colors.ThemeOrange} />}
            <p className={globalStyle.title}>Office Information</p>
          </div>
        </AccordionSummary>
        <AccordionDetails>
          <CreateOfficeInputs
            handleChangeName={handleChangeName}
            info={info}
          />
        </AccordionDetails>
      </Accordion>

      <Accordion>
        <AccordionSummary
          className={'accordion'}
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <div className={globalInputs.centerItem}>
            {info && <Circle number={2} back={Colors.ThemeOrange} />}
            <p className={globalStyle.title}>Office Expenses</p>
          </div>
        </AccordionSummary>
        <AccordionDetails>
          <Expenses />
        </AccordionDetails>
      </Accordion>

      <Accordion>
        <AccordionSummary
          className={'accordion'}
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <div className={globalInputs.centerItem}>
            {info && <Circle number={3} back={Colors.ThemeOrange} />}
            <p className={globalStyle.title}>Office Management</p>
          </div>
        </AccordionSummary>
        <AccordionDetails>
          <OfficeManagement />
        </AccordionDetails>
      </Accordion>

      <Accordion>
        <AccordionSummary
          className={'accordion'}
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <div className={globalInputs.centerItem}>
            {info && <Circle number={4} back={Colors.ThemeOrange} />}
            <p className={globalStyle.title}>Directory Access</p>
          </div>
        </AccordionSummary>
        <AccordionDetails>
          <DirectoryAccess />
        </AccordionDetails>
      </Accordion>

      <Accordion>
        <AccordionSummary
          className={'accordion'}
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <div className={globalInputs.centerItem}>
            {info && <Circle number={5} back={Colors.ThemeOrange} />}
            <p className={globalStyle.title}>Payroll Setup</p>
          </div>
        </AccordionSummary>
        <AccordionDetails>
          <div style={{ marginTop: 0, width: '100%' }}>
            <PayrollSetup info={info} />
          </div>
        </AccordionDetails>
      </Accordion>

      <Accordion>
        <AccordionSummary
          className={'accordion'}
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <div className={globalInputs.centerItem}>
            {info && <Circle number={6} back={Colors.ThemeOrange} />}
            <p className={globalStyle.title}>Documents</p>
          </div>
        </AccordionSummary>
        <AccordionDetails>
          <div className="info-table-no-line">
            <DocumentTable
              allDocs={info?.documents}
              documentsTypes={officeDockTypes}
              handleChangeStatus={handleSetDocStatus}
              changeStatusAction={EDIT_OFFICE_DOCK}
              handleDeleteDocument={handleDeleteFile}
              deleteDocAction={DELETE_OFFICE_DOCK}
              addLoadAction={ADD_OFFICE_DOCK}
              handleUploadFile={handleAddDocument}
              dontAllowAddDocument={!isAdmin}
            />
          </div>
        </AccordionDetails>
      </Accordion>
    </div>
  );
};